import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BlogPost.css";

const Blogpost = (props) => {
  return (
    <div className="card text-center col-sm-4" id="postcard">
      <div className="card-body">
        <h5 className="card-title">{props.post.Title}</h5>
        <p className="card-text">By: {props.post.Author}</p>
        <button className="btn btn-primary">Read More</button>
      </div>
    </div>
  );
};

export default Blogpost;
